const MIN_AUTOCOMPLETE_LENGTH = 2;

export function isAutocompletable(pattern: string): boolean {
  return pattern.trim().length >= MIN_AUTOCOMPLETE_LENGTH;
}
